import React, { useState } from 'react';
import { doc, setDoc, arrayUnion } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from './firebase';

export default function AdminCarga({
  pestanaCargaSub,
  setPestanaCargaSub,
  descargarPlantilla,
  manejarExcel,
  procesandoExcel,
  progresoExcel,
  subirPdfsEnBloque,
  procesandoPdf,
  progresoPdf,
  edificioIdActivo,
  nombreColeccion,
  obtenerRegistros,
  propietarios, 
  irAPrevisualizacion 
}) {
  // Estados para el formulario de carga individual de Excel/Datos
  const [mostrarFormInd, setMostrarFormInd] = useState(false);
  const [dptoInd, setDptoInd] = useState('');
  const [cuotaInd, setCuotaInd] = useState('');
  const [mesInd, setMesInd] = useState('Julio');
  const [anioInd, setAnioInd] = useState('2026');
  const [fEmisionInd, setFEmisionInd] = useState('');
  const [fVencInd, setFVencInd] = useState('');
  const [cargandoInd, setCargandoInd] = useState(false);

  // Estados para el formulario de PDF individual
  const [mostrarFormPdfInd, setMostrarFormPdfInd] = useState(false);
  const [dptoPdfInd, setDptoPdfInd] = useState('');
  const [archivoPdfIndUnico, setArchivoPdfIndUnico] = useState(null);
  const [cargandoPdfInd, setCargandoPdfInd] = useState(false);

  // Función para guardar el registro individual de datos en Firestore
  const guardarRegistroIndividual = async (e) => {
    e.preventDefault();
    if (!dptoInd || !cuotaInd) {
      alert("⚠️ Ingresa al menos el departamento y el total a pagar.");
      return;
    }
    if (!nombreColeccion) {
      alert("⚠️ Error: No hay una colección o edificio activo seleccionado.");
      return;
    }

    try {
      setCargandoInd(true);
      const dptoLimpio = dptoInd.trim();
      const docId = `dpto_${dptoLimpio.replace(/[^a-zA-Z0-9_]/g, '_')}`;

      const datosActualizacion = {
        departamento: dptoLimpio,
        cuota: `S/ ${parseFloat(String(cuotaInd).replace(/[^0-9.-]+/g, "")) || 0}`,
        mes: mesInd.trim() || 'Julio',
        anio: anioInd.trim() || '2026',
        fechaEmision: fEmisionInd.trim() || '-',
        fechaVencimiento: fVencInd.trim() || '-',
        estado: "Pendiente"
      };

      await setDoc(doc(db, nombreColeccion, docId), datosActualizacion, { merge: true });
      
      if (obtenerRegistros) {
        await obtenerRegistros();
      }

      setDptoInd('');
      setCuotaInd('');
      setFEmisionInd('');
      setFVencInd('');
      setMostrarFormInd(false);

      alert(`✅ ¡Recibo individual del Dpto. ${dptoLimpio} guardado con éxito!`);
    } catch (error) {
      console.error("Error al guardar registro individual:", error);
      alert("❌ Hubo un error al guardar el registro.");
    } finally {
      setCargandoInd(false);
    }
  };

  // Función para subir y vincular un PDF individual
  const guardarPdfIndividual = async (e) => {
    e.preventDefault();
    if (!dptoPdfInd || !archivoPdfIndUnico) {
      alert("⚠️ Ingresa el número de departamento (ej. 000 o 000_01) y selecciona un archivo PDF.");
      return;
    }
    if (!nombreColeccion) {
      alert("⚠️ Error: No hay una colección o edificio activo seleccionado.");
      return;
    }

    try {
      setCargandoPdfInd(true);
      const matchDpto = dptoPdfInd.trim().match(/\d+/);
      const dptoBase = matchDpto ? matchDpto[0] : dptoPdfInd.trim();
      const docId = `dpto_${dptoBase}`;

      const storageRef = ref(storage, `recibos_${edificioIdActivo || 'general'}/recibo_${dptoPdfInd.trim()}_${Date.now()}.pdf`);
      await uploadBytes(storageRef, archivoPdfIndUnico);
      const pdfUrlActual = await getDownloadURL(storageRef);

      await setDoc(doc(db, nombreColeccion, docId), {
        departamento: dptoBase,
        pdfUrl: pdfUrlActual,
        pdfUrls: arrayUnion({
          nombreArchivo: archivoPdfIndUnico.name,
          url: pdfUrlActual,
          subidoEn: new Date().toLocaleDateString('es-PE')
        })
      }, { merge: true });

      if (obtenerRegistros) {
        await obtenerRegistros();
      }

      setDptoPdfInd('');
      setArchivoPdfIndUnico(null);
      setMostrarFormPdfInd(false);

      alert(`✅ ¡PDF del departamento ${dptoBase} subido y agrupado con éxito!`);
    } catch (error) {
      console.error("Error al subir PDF individual:", error);
      alert("❌ Hubo un error al subir el PDF.");
    } finally {
      setCargandoPdfInd(false);
    }
  };

  return (
    <div style={{ textAlign: 'left' }}>
      <h2 style={{ marginTop: 0, color: '#1e293b' }}>Carga de Información</h2>
      <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '20px' }}>
        Sube la información financiera mediante Excel, gestión masiva de PDFs o registros individuales.
      </p>

      {/* Pestañas internas de Carga */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '25px' }}>
        <button 
          onClick={() => setPestanaCargaSub('excel')} 
          style={{ backgroundColor: pestanaCargaSub === 'excel' ? '#0284c7' : '#f1f5f9', color: pestanaCargaSub === 'excel' ? 'white' : '#334155', border: 'none', padding: '10px 18px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem' }}
        >
          📊 Excel (Montos y Fechas)
        </button>
        <button 
          onClick={() => setPestanaCargaSub('pdfs')} 
          style={{ backgroundColor: pestanaCargaSub === 'pdfs' ? '#0284c7' : '#f1f5f9', color: pestanaCargaSub === 'pdfs' ? 'white' : '#334155', border: 'none', padding: '10px 18px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem' }}
        >
          📤 PDFs (Recibos Masivos e Individuales)
        </button>
      </div>

      {pestanaCargaSub === 'excel' ? (
        <div>
          {/* Bloque principal de Excel */}
          <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '25px', textAlign: 'center', marginBottom: '25px' }}>
            <h3 style={{ marginTop: 0, color: '#1e293b', fontSize: '1.1rem' }}>Carga de Montos por Excel</h3>
            <p style={{ color: '#64748b', fontSize: '0.85rem', marginBottom: '20px' }}>
              Descarga la plantilla oficial, complétala con los montos y fechas de los recibos, y súbela a continuación.
            </p>
            <button onClick={descargarPlantilla} style={{ backgroundColor: '#0284c7', color: 'white', padding: '10px 18px', borderRadius: '6px', border: 'none', fontWeight: 'bold', cursor: 'pointer', marginBottom: '20px' }}>
              📥 Descargar Plantilla Excel
            </button>
            <br />
            <input type="file" accept=".xlsx, .xls, .csv" onChange={manejarExcel} disabled={procesandoExcel} style={{ padding: '10px', border: '1px dashed #cbd5e1', borderRadius: '6px', backgroundColor: 'white' }} />
            
            {procesandoExcel && (
              <div style={{ marginTop: '20px', maxWidth: '400px', margin: '20px auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', fontWeight: 'bold', marginBottom: '5px' }}>
                  <span>Procesando montos...</span>
                  <span>{progresoExcel}%</span>
                </div>
                <div style={{ width: '100%', backgroundColor: '#e2e8f0', borderRadius: '8px', height: '14px', overflow: 'hidden' }}>
                  <div style={{ width: `${progresoExcel}%`, backgroundColor: '#0284c7', height: '100%', transition: 'width 0.3s ease' }}></div>
                </div>
              </div>
            )}
          </div>

          {/* Botón para abrir el formulario de Carga Individual */}
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <button 
              onClick={() => setMostrarFormInd(!mostrarFormInd)} 
              style={{ backgroundColor: '#10b981', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem' }}
            >
              {mostrarFormInd ? '✖️ Cerrar Formulario Individual' : '➕ Agregar Registro Individual Manual'}
            </button>
          </div>

          {/* Formulario desplegable de Carga Individual */}
          {mostrarFormInd && (
            <div style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '10px', padding: '20px', marginBottom: '25px' }}>
              <h4 style={{ marginTop: 0, color: '#166534', fontSize: '1rem', marginBottom: '5px' }}>📝 Registrar Datos de un Departamento</h4>
              <p style={{ color: '#15803d', fontSize: '0.8rem', marginBottom: '15px' }}>
                Ingresa los datos exactos que corresponden a las columnas del sistema.
              </p>

              <form onSubmit={guardarRegistroIndividual} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <div style={{ flex: '1', minWidth: '140px' }}>
                    <label style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', marginBottom: '3px', color: '#166534' }}>Departamento:</label>
                    <input 
                      type="text" 
                      placeholder="Ej. 101" 
                      value={dptoInd} 
                      onChange={e => setDptoInd(e.target.value)}
                      style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #86efac', boxSizing: 'border-box', backgroundColor: 'white' }}
                      required 
                    />
                  </div>
                  <div style={{ flex: '1', minWidth: '140px' }}>
                    <label style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', marginBottom: '3px', color: '#166534' }}>Total a Pagar (S/):</label>
                    <input 
                      type="text" 
                      placeholder="Ej. 150.00" 
                      value={cuotaInd} 
                      onChange={e => setCuotaInd(e.target.value)}
                      style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #86efac', boxSizing: 'border-box', backgroundColor: 'white' }}
                      required 
                    />
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <div style={{ flex: '1', minWidth: '140px' }}>
                    <label style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', marginBottom: '3px', color: '#166534' }}>Mes:</label>
                    <input 
                      type="text" 
                      value={mesInd} 
                      onChange={e => setMesInd(e.target.value)}
                      style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #86efac', boxSizing: 'border-box', backgroundColor: 'white' }}
                      required 
                    />
                  </div>
                  <div style={{ flex: '1', minWidth: '140px' }}>
                    <label style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', marginBottom: '3px', color: '#166534' }}>Año:</label>
                    <input 
                      type="text" 
                      value={anioInd} 
                      onChange={e => setAnioInd(e.target.value)}
                      style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #86efac', boxSizing: 'border-box', backgroundColor: 'white' }}
                      required 
                    />
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <div style={{ flex: '1', minWidth: '140px' }}>
                    <label style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', marginBottom: '3px', color: '#166534' }}>Fecha de Emisión:</label>
                    <input 
                      type="text" 
                      placeholder="Ej. 01/07/2026" 
                      value={fEmisionInd} 
                      onChange={e => setFEmisionInd(e.target.value)}
                      style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #86efac', boxSizing: 'border-box', backgroundColor: 'white' }}
                    />
                  </div>
                  <div style={{ flex: '1', minWidth: '140px' }}>
                    <label style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', marginBottom: '3px', color: '#166534' }}>Fecha de Vencimiento:</label>
                    <input 
                      type="text" 
                      placeholder="Ej. 15/07/2026" 
                      value={fVencInd} 
                      onChange={e => setFVencInd(e.target.value)}
                      style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #86efac', boxSizing: 'border-box', backgroundColor: 'white' }}
                    />
                  </div>
                </div>

                <button 
                  type="submit" 
                  disabled={cargandoInd}
                  style={{ backgroundColor: '#16a34a', color: 'white', border: 'none', padding: '10px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem', marginTop: '5px' }}
                >
                  {cargandoInd ? 'Guardando...' : 'Guardar Registro Individual ✓'}
                </button>
              </form>
            </div>
          )}
        </div>
      ) : (
        <div>
          {/* Bloque principal de Carga Masiva de PDFs */}
          <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '25px', textAlign: 'center', marginBottom: '25px' }}>
            <h3 style={{ marginTop: 0, color: '#1e293b', fontSize: '1.1rem' }}>Carga Masiva de Recibos en PDF</h3>
            
            <div style={{ backgroundColor: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '8px', padding: '15px', marginBottom: '20px', textAlign: 'left' }}>
              <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#1e40af', fontSize: '0.85rem' }}>💡 Instrucciones para nombrar los archivos PDF:</p>
              <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', color: '#1e3a8a', fontSize: '0.85rem', lineHeight: '1.5' }}>
                <li><strong>Departamento con 1 recibo:</strong> Solo el número del departamento (Ej: <code style={{ backgroundColor: '#dbeafe', padding: '2px 6px', borderRadius: '4px' }}>101.pdf</code>).</li>
                <li><strong>Departamento con múltiples recibos:</strong> Usa sufijos con guion bajo (Ej: <code style={{ backgroundColor: '#dbeafe', padding: '2px 6px', borderRadius: '4px' }}>101_01.pdf</code> y <code style={{ backgroundColor: '#dbeafe', padding: '2px 6px', borderRadius: '4px' }}>101_02.pdf</code>).</li>
              </ul>
            </div>

            <input type="file" accept=".pdf" multiple onChange={subirPdfsEnBloque} disabled={procesandoPdf} style={{ padding: '10px', border: '1px dashed #cbd5e1', borderRadius: '6px', backgroundColor: 'white' }} />
            
            {procesandoPdf && (
              <div style={{ marginTop: '20px', maxWidth: '400px', margin: '20px auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', fontWeight: 'bold', marginBottom: '5px' }}>
                  <span>Subiendo recibos PDF...</span>
                  <span>{progresoPdf}%</span>
                </div>
                <div style={{ width: '100%', backgroundColor: '#e2e8f0', borderRadius: '8px', height: '14px', overflow: 'hidden' }}>
                  <div style={{ width: `${progresoPdf}%`, backgroundColor: '#10b981', height: '100%', transition: 'width 0.3s ease' }}></div>
                </div>
              </div>
            )}
          </div>

          {/* Botón para abrir el formulario de PDF Individual */}
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <button 
              onClick={() => setMostrarFormPdfInd(!mostrarFormPdfInd)} 
              style={{ backgroundColor: '#0284c7', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem' }}
            >
              {mostrarFormPdfInd ? '✖️ Cerrar Formulario PDF Individual' : '➕ Subir un PDF Individual Manual'}
            </button>
          </div>

          {/* Formulario desplegable de PDF Individual */}
          {mostrarFormPdfInd && (
            <div style={{ backgroundColor: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '10px', padding: '20px', marginBottom: '25px' }}>
              <h4 style={{ marginTop: 0, color: '#1e40af', fontSize: '1rem', marginBottom: '5px' }}>📤 Subir y Vincular PDF Individual</h4>
              <p style={{ color: '#1e3a8a', fontSize: '0.8rem', marginBottom: '15px' }}>
                Ingresa el número de departamento o sufijo exacto (Ej: <code style={{ backgroundColor: '#dbeafe', padding: '2px 4px', borderRadius: '4px' }}>101</code> o <code style={{ backgroundColor: '#dbeafe', padding: '2px 4px', borderRadius: '4px' }}>101_01</code>) y selecciona el archivo PDF.
              </p>

              <form onSubmit={guardarPdfIndividual} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <label style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', marginBottom: '3px', color: '#1e40af' }}>Número de Departamento o Sufijo:</label>
                  <input 
                    type="text" 
                    placeholder="Ej. 101 o 101_01" 
                    value={dptoPdfInd} 
                    onChange={e => setDptoPdfInd(e.target.value)}
                    style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #93c5fd', boxSizing: 'border-box', backgroundColor: 'white' }}
                    required 
                  />
                </div>

                <div>
                  <label style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', marginBottom: '3px', color: '#1e40af' }}>Archivo PDF del Recibo:</label>
                  <input 
                    type="file" 
                    accept=".pdf" 
                    onChange={e => setArchivoPdfIndUnico(e.target.files[0])}
                    style={{ padding: '6px', border: '1px dashed #93c5fd', borderRadius: '6px', backgroundColor: 'white', width: '100%', boxSizing: 'border-box', fontSize: '0.85rem' }}
                    required 
                  />
                </div>

                <button 
                  type="submit" 
                  disabled={cargandoPdfInd}
                  style={{ backgroundColor: '#0284c7', color: 'white', border: 'none', padding: '10px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem', marginTop: '5px' }}
                >
                  {cargandoPdfInd ? 'Subiendo y vinculando...' : 'Subir y Vincular PDF ✓'}
                </button>
              </form>
            </div>
          )}
        </div>
      )}

      {/* 📋 RESUMEN DE CARGAS ACTUALES (VISTA PREVIA INTERNA) */}
      <div style={{ marginTop: '35px', backgroundColor: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '20px', boxShadow: '0 4px 6px rgba(0,0,0,0.02)' }}>
        <h3 style={{ marginTop: 0, color: '#1e293b', fontSize: '1.1rem' }}>📋 Resumen de Cargas Actuales</h3>
        <p style={{ color: '#64748b', fontSize: '0.85rem', marginBottom: '15px' }}>
          Verifica aquí los departamentos que ya cuentan con montos, fechas y PDFs cargados en este momento.
        </p>

        <div style={{ overflowX: 'auto', width: '100%' }}>
          <table className="tabla-propietarios" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
            <thead>
              <tr>
                <th style={{ padding: '8px', borderBottom: '1px solid #cbd5e1' }}>Dpto.</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #cbd5e1' }}>Propietario</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #cbd5e1' }}>Cuota</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #cbd5e1' }}>Mes/Año</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #cbd5e1' }}>F. Emisión</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #cbd5e1' }}>F. Vencimiento</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #cbd5e1' }}>PDFs Asociados</th>
              </tr>
            </thead>
            <tbody>
              {!propietarios || propietarios.length === 0 ? (
                <tr><td colSpan="7" style={{ textAlign: 'center', padding: '20px', color: '#666' }}>No hay registros cargados aún.</td></tr>
              ) : (
                propietarios.map(prop => (
                  <tr key={prop.id}>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f1f5f9' }}>{prop.departamento}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f1f5f9' }}>{prop.nombre || 'Sin registrar'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f1f5f9' }}>{prop.cuota || 'S/ 0.00'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f1f5f9' }}>{prop.mes || '-'} / {prop.anio || '-'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f1f5f9' }}>{prop.fechaEmision || '-'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f1f5f9' }}>{prop.fechaVencimiento || '-'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f1f5f9' }}>
                      {prop.pdfUrls && prop.pdfUrls.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                          {prop.pdfUrls.map((pdf, idx) => (
                            <a key={idx} href={pdf.url || pdf} target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', fontWeight: 'bold', fontSize: '0.75rem', textDecoration: 'underline' }}>
                              📄 PDF {idx + 1} ↗
                            </a>
                          ))}
                        </div>
                      ) : prop.pdfUrl ? (
                        <a href={prop.pdfUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', fontWeight: 'bold', fontSize: '0.75rem', textDecoration: 'underline' }}>
                          📄 Ver PDF ↗
                        </a>
                      ) : (
                        <span style={{ color: '#dc2626', fontSize: '0.75rem', fontStyle: 'italic' }}>Sin PDF</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* 🚀 Botón Global para mandar la información a Revisión y Previsualización */}
      <div style={{ marginTop: '25px', padding: '22px', backgroundColor: '#faf5ff', border: '1px solid #e9d5ff', borderRadius: '10px', textAlign: 'center' }}>
        <h4 style={{ margin: '0 0 6px 0', color: '#6b21a8', fontSize: '1.05rem' }}>🚀 Paso Siguiente: Revisión y Aprobación</h4>
        <p style={{ fontSize: '0.85rem', color: '#7e22ce', marginBottom: '15px' }}>
          ¿Ya verificaste el resumen? Pasa a la previsualización oficial para realizar envíos y aprobaciones finales.
        </p>
        <button
          onClick={irAPrevisualizacion}
          style={{ backgroundColor: '#7c3aed', color: 'white', border: 'none', padding: '12px 24px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.95rem', display: 'inline-flex', alignItems: 'center', gap: '8px', boxShadow: '0 4px 6px -1px rgba(124, 58, 237, 0.2)' }}
        >
          👁️ Ir a Previsualización y Revisión
        </button>
      </div>
    </div>
  );
}